(() => {
    /* ––– 0. Config ––– */
    const API_BASE = window.COLOR_APP_BASE ||
                     'https://color-swatches-app-production.up.railway.app';
    const collectionId = window.COLLECTION_ID;
    if (!collectionId) return;
  
    /* ––– 1. Detect market ––– */
    const detectMarket = () =>
      (window.Shopify?.country ||
       window.Shopify?.localization?.country?.iso_code ||
       document.documentElement.lang?.split('-').pop() || '')
        .toLowerCase() === 'us' ? 'us' : 'ca';
  
    /* ––– 2. Helpers (hide & mark swatches) ––– */
    const canon = str => (str||'').trim().replace(/^_+/, '').replace(/\s+/g,' ').toLowerCase();
  
    const markCard = (cardEl, soldOut = []) => {
      const soldOutSet = new Set(soldOut.map(canon));
      cardEl.querySelectorAll('.color-swatch[data-color]').forEach(sw => {
        if (soldOutSet.has(canon(sw.dataset.color))) {
          sw.style.display = 'none';
          sw.dataset.hide = '1';
          sw.classList.remove('active');
        } else {
          sw.style.display = '';
          delete sw.dataset.hide;
        }
      });
      if (!cardEl.querySelector('.color-swatch.active:not([data-hide])')) {
        const first = cardEl.querySelector('.color-swatch:not([data-hide])');
        if (first) first.classList.add('active');
      }
      const hasVisible = cardEl.querySelector('.color-swatch:not([data-hide])');
      const titleTxt = cardEl.querySelector('.product-card__title')?.textContent || '';
      const isBundle = /pack|bundle/i.test(titleTxt);
      if (!hasVisible && !isBundle) {
        cardEl.style.display = 'none';
        cardEl.dataset.hideCard = '1';
      } else {
        cardEl.style.display = '';
        delete cardEl.dataset.hideCard;
      }
    };
  
    const applyInventoryMap = data => {
      // cache for later
      window.__collectionInventoryCache = data;
  
      document
        .querySelectorAll('.product-card[data-product-id]')
        .forEach(card => {
          markCard(card, data[card.dataset.productId]?.sold_out_colors);
  
          // swap featured image if its color isn't in stock
          const variantEl = card.querySelector('.product-card__variant-color');
          const current = variantEl?.textContent.trim().toLowerCase();
          const available = Array.from(
            card.querySelectorAll('.color-swatch:not([data-hide])')
          );
          if (available.length && !available.some(sw => sw.dataset.color.trim().toLowerCase() === current)) {
            card.querySelectorAll('.color-swatch.active').forEach(sw => sw.classList.remove('active'));
            setTimeout(() => {
              available[0].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            }, 0);
          }
        });
  
      document.body.dataset.inventoryReady = '1';
    };
  
    /* ––– 3. Fetch once + cache ––– */
    const market = detectMarket();
    const invUrl = `${API_BASE}/inventory/collection?collectionId=${collectionId}&market=${market}`;
    const invPromise = window.__invPromise
      ? Promise.resolve(window.__invPromise)
      : fetch(invUrl)
          .then(res => {
            if (!res.ok) throw new Error(`Inventory API error: ${res.status}`);
            return res.json();
          })
          .then(data => {
            window.__invPromise = data;
            return data;
          });
    invPromise
      .then(data => {
        window.__collectionInventoryCache = data;
        applyInventoryMap(data);
      })
      .catch(console.error);
  
    /* ––– 4. One body-wide observer for all new cards ––– */
    new MutationObserver(muts => {
      if (!window.__collectionInventoryCache) return;
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches('.product-card') || n.querySelector('.product-card'))) {
            applyInventoryMap(window.__collectionInventoryCache);
            return;  // no need to keep looping once we’ve reapplied
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  
  })();
  